import * as React from "react";
import orderBy from 'lodash-es/orderBy';
import Loading, { FontSize } from "./loading";
import { DateTimeAccuracy, LocalizedDateTime } from "./LocalizedDateTime";
import { TextArea } from "../../forms/informedv2/TextArea";
import { Form, useFormApi } from "informed";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { TestNote, SessionNote, SubjectNote } from "webportalclient";

interface NotesModalBodyProps {
    notes: SessionNote[] | SubjectNote[] | TestNote[];
    isAddingNote: boolean;
    disabled: boolean;
    onAdd: (annotation: string) => void;
    onCloseModal: () => void;
    changeButtonText?: string;
}

interface NotesForm {
    Annotation: string;
}

export const NotesModalBodyForm = ({ notes, isAddingNote, disabled, onAdd, onCloseModal, changeButtonText }: NotesModalBodyProps) => {
    const formApi = useFormApi<NotesForm>();

    const validateMax1000Characters = value => {
        if (!value) {
            return "Annotation is required";
        }

        if (value.length > 1000)
            return "The Annotation field has a maximum length of 1000 characters";

        return undefined;
    };

    const renderRow = (note: SessionNote) => {
        return (
            <tr key={`Note${note.id}`}>
                <td data-automationid={`notes-modal-user-${note.id}`}>{note.userEmailAddress}</td>
                <td style={{ whiteSpace: 'nowrap' }}><LocalizedDateTime automationId={`notes-modal-created-${note.id}`} time={note.recorded} accuracy={DateTimeAccuracy.Second} isTooltip={true} /></td>
                <td style={{ wordBreak: 'break-all' }} data-automationid={`notes-modal-comment-${note.id}`}>{note.comment}</td>
            </tr>
        );
    }

    const handleSubmit = async () => {
        formApi.validate();
        const state = formApi.getState();

        if (state.invalid)
            return;

        onAdd(state.values.Annotation);

        formApi.setValue("Annotation", null);
    }

    return (
        <ErrorBoundary>
            <div className="modal-body">
                <table className="table">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Created</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            orderBy(notes, ["CreatedDate"], ["desc"]).map(i => {
                                return renderRow(i);
                            })
                        }
                    </tbody>
                </table>
                {isAddingNote ? <Loading size={FontSize.OneX} /> : null}
                {disabled ? null :
                    <div>
                        <label htmlFor="Annotation">Annotation</label>
                        <TextArea field="Annotation" id="Annotation" validate={validateMax1000Characters} />
                    </div>
                }
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="button" disabled={isAddingNote || disabled} data-automationid="NotesModalAddButton"
                    onClick={handleSubmit}>
                    {changeButtonText != undefined ? changeButtonText : "Add"}
                </button>
                <button className="btn btn-primary btn-outline" data-automationid="NotesModalCancelButton" onClick={() => onCloseModal()}>
                    Cancel
                </button>
            </div>
        </ErrorBoundary>
    );
}

export const NotesModalBody = (props: NotesModalBodyProps) => {
    return (
        <Form>
            <NotesModalBodyForm  {...props} />
        </Form>
    );
}
